import React from "react";
import { useTranslation } from "react-i18next";
import { DocketSwitch } from "../form/DocketSwitch";
import { IconButton } from "../IconButton/IconButton";

interface SearchFormHeaderProps {
  showChildSearch: boolean;
  showChild: Function;
  deleteSearch: Function;
  showDelete: boolean;
}

export function SearchFormHeader({
  showChildSearch,
  showChild,
  deleteSearch,
  showDelete,
}: SearchFormHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="md:p-6 max-md:pt-6">
      <p className="text-dark dark:text-white text-2xl">{t("immunizations.search_start_header")}</p>
      <hr />
      <div className="mb-5 mt-5 flex">
        <div>
          <label className="label text-[16px] font-[700] text-black dark:text-white max-md:text-white mb-3">
            {t("immunizations.search_child_search")}
            <span className="required-tag">*</span>
          </label>
          <div className="flex">
            <label className="radio-control mr-5 text-dark dark:text-white">
              <input
                type="radio"
                name="childSearch"
                data-testid="adult-search-toggle"
                onChange={() => showChild(false)}
                checked={!showChildSearch}
              />
              &nbsp;&nbsp;{t("immunizations.search_adult_records")}
            </label>
            <label className="radio-control text-dark dark:text-white">
              <input
                type="radio"
                name="childSearch"
                onChange={() => showChild(true)}
                data-testid="child-search-toggle"
                checked={showChildSearch}
              />
              &nbsp;&nbsp;{t("immunizations.search_child_records")}
            </label>
          </div>
        </div>
        {showDelete && (
          <div className="has-text-dark ml-auto">
            <IconButton
              dataTestId="deleteBtn"
              icon="trash"
              onClick={() => deleteSearch()}
              alt="delete"
            />
          </div>
        )}
      </div>

      <hr />
    </div>
  );
}

export default SearchFormHeader;
